import type { Reducer } from 'redux';

import type {
  EditGroupSettingsFulfilledAction,
  NetworkGroupSettingsAction,
} from '../../domains/networkGroupSettings/actions.types';
import type { NetworkGroupSettings } from '../types';

const editGroupSettings = (
  state: NetworkGroupSettings,
  payload: EditGroupSettingsFulfilledAction['payload']
): NetworkGroupSettings => {
  const updatedGroupSettings = payload.editGroupSettings?.settings;

  if (!state) {
    return state;
  }

  if (!updatedGroupSettings) {
    return state;
  }

  return {
    ...state,
    isSensitivityLabelRequired: updatedGroupSettings.isSensitivityLabelRequired,
    isSensitivityLabelRequiredForPrivateGroups: updatedGroupSettings.isSensitivityLabelRequiredForPrivateGroups,
    isSensitivityLabelRequiredForPublicGroups: updatedGroupSettings.isSensitivityLabelRequiredForPublicGroups,
  };
};

const reducer: Reducer<NetworkGroupSettings, NetworkGroupSettingsAction> = (state = null, action) => {
  switch (action.type) {
    case 'NETWORK_GROUP_SETTINGS.FULFILLED':
      return action.payload;
    case 'EDIT_GROUP_SETTINGS.FULFILLED':
      return editGroupSettings(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
